module.exports = __webpack_public_path__ + "img/jeff-siepman-hK9hIPgF3QU-unsplash.bbcc593f.jpg";